// extracted by mini-css-extract-plugin
export default {"bg":"modal_bg__gnFux","modal":"modal_modal__SCcdg","title":"modal_title__nKBHr"};